import { render, staticRenderFns } from "./TheBookingList.vue?vue&type=template&id=5fa537cc&scoped=true"
import script from "./TheBookingList.vue?vue&type=script&lang=ts"
export * from "./TheBookingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa537cc",
  null
  
)

export default component.exports